import React from "react";
import RoboticsShell from "./RoboticsShell";

/**
 * Robotics Showcase page — public gallery placeholder.
 *
 * Phase 1 skeleton only. Phase 3+ will populate it with sample workbook
 * covers, schematic previews, and capstone-project galleries.
 */
export default function RoboticsShowcase() {
  return (
    <RoboticsShell>
      <section className="rbx-page" data-testid="rbx-page-showcase">
        <span className="rbx-eyebrow">Section · Public showcase</span>
        <h1 className="rbx-page__title" data-testid="rbx-showcase-title">Bench + Blueprint</h1>
        <p className="rbx-page__lede">
          Sample schematics, workbook covers and capstone-project galleries
          will appear here once content generation completes. This page is
          intentionally schematic-first — a workshop wall, not a bookshelf.
        </p>
        <div className="rbx-coming-soon" data-testid="rbx-showcase-status">
          Awaiting Phase 3 content generation
        </div>
      </section>
    </RoboticsShell>
  );
}
